export const StarterGradientIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M2.04419 18.4392C3.97969 16.7447 6.83606 15.6729 10.0221 15.6729C13.2082 15.6729 16.0645 16.7447 18 18.4392"
        stroke="url(#paint0_linear_5649_22058)"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M10.0887 15.6392C10.0887 10.7138 14.2137 7.17081 17.2499 6.125C17.2499 9.1875 15.1249 13.0625 11.4719 11.2536"
        stroke="url(#paint1_linear_5649_22058)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0558 15.5717C10.0879 13.4512 9.52337 11.0435 8.25 9.25M8.25 9.25C5.9553 10.2958 1.97514 7.96804 2.4813 2.46911C7.87963 2.46911 10.6446 6.68608 8.25 9.25ZM8.25 9.25C6.76489 7.15838 6.49796 6.69567 5.25 5.3125"
        stroke="url(#paint2_linear_5649_22058)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_5649_22058"
          x1="17.818"
          y1="15.8095"
          x2="2.28407"
          y2="19.2219"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC934" />
          <stop offset="0.293264" stopColor="#F9AD11" />
          <stop offset="1" stopColor="#EE8330" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_5649_22058"
          x1="17.1682"
          y1="6.59473"
          x2="9.86598"
          y2="6.80406"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC934" />
          <stop offset="0.293264" stopColor="#F9AD11" />
          <stop offset="1" stopColor="#EE8330" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_5649_22058"
          x1="9.97017"
          y1="3.11602"
          x2="2.1979"
          y2="3.28816"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFC934" />
          <stop offset="0.293264" stopColor="#F9AD11" />
          <stop offset="1" stopColor="#EE8330" />
        </linearGradient>
      </defs>
    </svg>
  )
}
